import React from "react";
import {
  Typography, Grid, TextField, Accordion, AccordionSummary,
  AccordionDetails, FormControl, InputLabel, Select, MenuItem
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const STATI = [
  { id: "qualificazione", label: "Qualificazione" },
  { id: "preventivo", label: "Preventivo" },
  { id: "chiusoAcquisito", label: "Chiuso Acquisito" },
  { id: "chiusoPerso", label: "Chiuso Perso" },
  { id: "completato", label: "Completato" },
  { id: "annullato", label: "Annullato" },
  { id: "rimandato", label: "Rimandato" },
  { id: "fatturato", label: "Fatturato" },
  { id: "archiviato", label: "Archiviato" },
];

export default function SezioneStato({ form, handleChange }) {
  return (
    <Accordion defaultExpanded elevation={1} sx={{ mb: 2 }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: "#F2F2F2" }}>
        <Typography fontWeight="bold">Stato</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2} mt={0}>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel>Stato evento</InputLabel>
              <Select value={form.stato} label="Stato evento"
                onChange={(e) => handleChange("stato", e.target.value)}>
                {STATI.map((s) => (
                  <MenuItem key={s.id} value={s.id}>{s.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          {(form.stato === "annullato" || form.stato === "rimandato") && (
            <Grid item xs={12}>
              <TextField fullWidth multiline rows={2}
                label="Motivo annullamento/rinvio" value={form.motivoAnnullamento || ""}
                onChange={(e) => handleChange("motivoAnnullamento", e.target.value)} />
            </Grid>
          )}
          {form.stato === "rimandato" && (
            <Grid item xs={12} md={6}>
              <TextField fullWidth label="Nuova data (opzionale)" type="date"
                value={form.nuovaData || ""}
                onChange={(e) => handleChange("nuovaData", e.target.value)}
                InputLabelProps={{ shrink: true }} />
            </Grid>
          )}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}